function ErrorsList({ errors }: { errors: string[] }) {
  return (
    <div className="my-1 flex max-w-full flex-col gap-2 rounded-md bg-red-200 px-3 py-3 text-sm text-red-500">
      <ul className="max-w-full">
        {errors.map((error, i) => (
          <li className="max-w-full py-1" key={i}>
            <p className="max-w-full text-wrap">
              {i + 1} - {error}
            </p>
          </li>
        ))}
      </ul>
    </div>
  );
}

export default ErrorsList;
